import { ComponentProps, useRef } from "react";
import { useMatch, useSearchParams } from "react-router-dom";
import { MeganPage, getMFEConfig } from "@sunrun/sales-experience-shared";
import { useIframeMessages, useSynchronizeUrl } from "./common";
import type { IFrame } from "components/atoms/IFrame";

const useMeganAdapter = (page: MeganPage): ComponentProps<typeof IFrame> => {
  let [searchParams] = useSearchParams();
  const ref = useRef<HTMLIFrameElement | null>(null);
  const config = getMFEConfig("megan", page);
  const basePath = config.iFrameUrl;
  const aliasMatch = useMatch("/sales-support/*");
  const containerMatch = useMatch(`/${config.containerPath}/*`);
  const match = aliasMatch ?? containerMatch;
  const src = `${basePath}/${match?.params["*"] ?? ""}?${searchParams}`;
  const { staticSrc } = useSynchronizeUrl(ref, src, basePath);
  useIframeMessages(ref, "Megan", config.containerPath);
  return {
    ref,
    basePath: basePath,
    src: staticSrc,
    title: config.title,
  };
};

export { useMeganAdapter };
